export default function Title() {
  return (
    <h1 className="fs-900 medium clr-white">
      Join the country's most <span>Innovative Community</span>!
    </h1>
  );
}
